<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Admin Order Status Notification</h1>
            <hr>
            <mdb-row>
                <mdb-col md="4">
                    <mdb-autocomplete
                    :data="users"
                    label="Name / Phone Number"
                    v-model="search"
                    :isAsync="true"
                    @search="requestUser"
                    :filterFunction="filterFunction"
                    />
                    <!-- <mdb-input label="Name / Phone Number" v-model="search" size="sm" /> -->
                </mdb-col>
                <mdb-col md="3">
                    <mdb-select
                    v-model="selection_options"
                    label="Notification Type"
                    @getValue="selectType"
                    />
                </mdb-col>
                <mdb-col md="3" class="align-self-center">
                    <mdb-btn v-if="!loading" @click="submitAdminNotification()" color="primary" size="sm">Submit</mdb-btn>
                    <mdb-spinner small v-if="loading" color="blue" />
                </mdb-col>
            </mdb-row>
            <p class="text-danger">Must Select User from the List before Submit</p>
            <h4 class="h4-responsive font-weight-bold">Order Placed</h4>
            <mdb-tbl responsive striped bordered>
                <mdb-tbl-head>
                  <tr>
                      <th width="5%">#</th>
                      <th width="35%">Name</th>
                      <th width="35%">Type</th>
                      <th width="25%">Action</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                    <tr v-for="(user, index) in status_list_order_placed" :key="user.id">
                        <td>{{index+1}}</td>
                        <td>
                            <div>{{user.user.name}}</div>
                            <div>{{user.user.phone_number}}</div>
                        </td>
                        <td>{{user.type}}</td>
                        <td>
                            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Delete User Notification</span>
                                <a @click="openConfirmationModal(user)" slot="reference">
                                    <i class="fas fa-trash px-2 text-danger"></i>
                                </a>
                            </mdb-tooltip>
                        </td>
                    </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <h4 class="h4-responsive font-weight-bold">Pending Merchant Accept</h4>
            <mdb-tbl responsive striped bordered>
                <mdb-tbl-head>
                  <tr>
                      <th width="5%">#</th>
                      <th width="35%">Name</th>
                      <th width="35%">Type</th>
                      <th width="25%">Action</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                    <tr v-for="(user, index) in status_list_not_accept" :key="user.id">
                        <td>{{index+1}}</td>
                        <td>
                            <div>{{user.user.name}}</div>
                            <div>{{user.user.phone_number}}</div>
                        </td>
                        <td>{{user.type}}</td>
                        <td>
                            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Delete User Notification</span>
                                <a @click="openConfirmationModal(user)" slot="reference">
                                    <i class="fas fa-trash px-2 text-danger"></i>
                                </a>
                            </mdb-tooltip>
                        </td>
                    </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <h4 class="h4-responsive font-weight-bold">Merchant Cancelled</h4>
            <mdb-tbl responsive striped bordered>
                <mdb-tbl-head>
                  <tr>
                      <th width="5%">#</th>
                      <th width="35%">Name</th>
                      <th width="35%">Type</th>
                      <th width="25%">Action</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                    <tr v-for="(user, index) in status_list_merchant_cancelled" :key="user.id">
                        <td>{{index+1}}</td>
                        <td>
                            <div>{{user.user.name}}</div>
                            <div>{{user.user.phone_number}}</div>
                        </td>
                        <td>{{user.type}}</td>
                        <td>
                            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Delete User Notification</span>
                                <a @click="openConfirmationModal(user)" slot="reference">
                                    <i class="fas fa-trash px-2 text-danger"></i>
                                </a>
                            </mdb-tooltip>
                        </td>
                    </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <h4 class="h4-responsive font-weight-bold">Merchant Timeout</h4>
            <mdb-tbl responsive striped bordered>
                <mdb-tbl-head>
                  <tr>
                      <th width="5%">#</th>
                      <th width="35%">Name</th>
                      <th width="35%">Type</th>
                      <th width="25%">Action</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                    <tr v-for="(user, index) in status_list_merchant_timeout" :key="user.id">
                        <td>{{index+1}}</td>
                        <td>
                            <div>{{user.user.name}}</div>
                            <div>{{user.user.phone_number}}</div>
                        </td>
                        <td>{{user.type}}</td>
                        <td>
                            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Delete User Notification</span>
                                <a @click="openConfirmationModal(user)" slot="reference">
                                    <i class="fas fa-trash px-2 text-danger"></i>
                                </a>
                            </mdb-tooltip>
                        </td>
                    </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <h4 class="h4-responsive font-weight-bold">No Rider</h4>
            <mdb-tbl responsive striped bordered>
                <mdb-tbl-head>
                  <tr>
                      <th width="5%">#</th>
                      <th width="35%">Name</th>
                      <th width="35%">Type</th>
                      <th width="25%">Action</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                    <tr v-for="(user, index) in status_list_no_rider" :key="user.id">
                        <td>{{index+1}}</td>
                        <td>
                            <div>{{user.user.name}}</div>
                            <div>{{user.user.phone_number}}</div>
                        </td>
                        <td>{{user.type}}</td>
                        <td>
                            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Delete User Notification</span>
                                <a @click="openConfirmationModal(user)" slot="reference">
                                    <i class="fas fa-trash px-2 text-danger"></i>
                                </a>
                            </mdb-tooltip>
                        </td>
                    </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <h4 class="h4-responsive font-weight-bold">Switch Rider</h4>
            <mdb-tbl responsive striped bordered>
                <mdb-tbl-head>
                  <tr>
                      <th width="5%">#</th>
                      <th width="35%">Name</th>
                      <th width="35%">Type</th>
                      <th width="25%">Action</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                    <tr v-for="(user, index) in status_list_rider_switch" :key="user.id">
                        <td>{{index+1}}</td>
                        <td>
                            <div>{{user.user.name}}</div>
                            <div>{{user.user.phone_number}}</div>
                        </td>
                        <td>{{user.type}}</td>
                        <td>
                            <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                                <span slot="tip">Delete User Notification</span>
                                <a @click="openConfirmationModal(user)" slot="reference">
                                    <i class="fas fa-trash px-2 text-danger"></i>
                                </a>
                            </mdb-tooltip>
                        </td>
                    </tr>
                </mdb-tbl-body>
            </mdb-tbl>
            <ConfirmationModal :visible="confirmation_modal" :close="closeModalComponent" title="Confirm Delete User Notification?" :submit="deleteNotification" />
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbRow, mdbCol, mdbBtn, mdbSpinner, mdbAutocomplete, mdbSelect, mdbTbl, mdbTblHead, mdbTblBody, mdbTooltip } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import ConfirmationModal from '../components/ConfirmationModal';

export default {
  name: 'admin_order_status_notification',
  components: {
    mdbContainer, mdbRow, mdbCol, mdbBtn, mdbSelect, mdbTooltip, ConfirmationModal,
    AppNavigation, mdbSpinner, mdbAutocomplete, mdbTbl, mdbTblHead, mdbTblBody
  },
  data: ()=>({
        focus_index: 0,
        loading: false,
        search: "",
        users: [],
        model: [],
        timer: null,
        selected_user_id: 0,
        status_list_order_placed: [],
        status_list_not_accept: [],
        status_list_merchant_cancelled: [],
        status_list_merchant_timeout: [],
        status_list_no_rider: [],
        status_list_rider_switch: [],
        selected_type: null,
        confirmation_modal: false,
        selection_options: [
          { text: "New Order Placed", value: "ORDER_PLACED" },
          { text: "Pending Merchant Accept", value: "MERCHANT_NOT_ACCEPT" },
          { text: "Merchant Cancelled", value: "MERCHANT_CANCELLED" },
          { text: "Merchant Timeout", value: "MERCHANT_TIMOUT" },
          { text: "No Rider", value: "NO_RIDER" },
          { text: "Rider Assigned", value: "RIDER_ASSIGN" }
        ]
  }),
  methods: {
      closeModalComponent(){
          this.confirmation_modal=false;
      },
      requestUser(search){
          clearTimeout(this.timer);
          this.selected_user_id=0;
          this.timer=setTimeout(()=>{
              ajax({
              url: "admin/list_filter_users",
              data: {search: search},
              success: result=>{
                  let users =[];
                  result.data.forEach(user => {
                    users.push(user.name);
                  });
                  this.model=result.data;
                  this.users=users;
              }
            }, this)
          }, 1000)
      },
      filterFunction(item, search){
        if(item.toLowerCase().indexOf(search.toLowerCase()) > -1){
                let index = this.model.findIndex(user=>{
                    return user.name==item;
                })
                this.selected_user_id=this.model[index].id;
        }
      },
      submitAdminNotification(){
        if(this.loading){
            return false;
        }
        if(this.selected_user_id==0 || this.selected_type==null){
            this.$notify.error({message: 'Please key in all required fields', position:'top right', timeOut: 5000});
            return false;
        }
        this.loading=true;
        ajax({
            url: "admin/submit_admin_order_notification",
            data: {user_id: this.selected_user_id, type: this.selected_type},
            success: ()=>{
                this.getData();
                this.$notify.success({message: 'User added into the notification list', position:'top right', timeOut: 5000});
            },
            complete: ()=>this.loading=false
        }, this)    
      },
      selectType(type){
          this.selected_type=type;
      },
      getData(){
          this.loading=true;
          ajax({
            url: "admin/get_admin_status_notifications",
            success: result=>{
                this.status_list_order_placed=result.data.ORDER_PLACED;
                this.status_list_not_accept=result.data.MERCHANT_NOT_ACCEPT;
                this.status_list_merchant_cancelled=result.data.MERCHANT_CANCELLED;
                this.status_list_merchant_timeout=result.data.MERCHANT_TIMOUT;
                this.status_list_no_rider=result.data.NO_RIDER;
                this.status_list_rider_switch=result.data.RIDER_ASSIGN;
            },
            complete: ()=>this.loading=false
        }, this)  
      },
      deleteNotification(){
            this.loading=true;
          ajax({
            url: "admin/delete_admin_order_notification",
            data: {id: this.focus_index},
            success: ()=>{
                this.getData();
                this.$notify.success({message: 'User Notification Deleted', position:'top right', timeOut: 5000});
            },
            complete: ()=>this.loading=false
        }, this) 
      },
      openConfirmationModal(user){
          this.focus_index=user.id;
          this.confirmation_modal=true;
      }
  },
  mounted: function(){
      this.getData();
  }
}
</script>
